module.exports = __webpack_public_path__ + "static/media/oncourse-logo.748d0531.png";